import React, {Component} from 'react';
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types';
import {Container, Row, Col, CardGroup, Card, CardBody, Button } from 'reactstrap';

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {LoginField} from '../../../views/controls/_FieldValication'
import { logout } from '../../../views/client/actions'
import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import { validateActiveAcc } from '../../../lib/validation'

// Import actions
import activeAccRequest, {reActiveAccRequest} from './actions';

class ActiveAcc extends Component {
  // Pass the correct proptypes in for validation
  static propTypes = {
    handleSubmit: PropTypes.func,
    activeAccRequest: PropTypes.func,
    logout: PropTypes.func,
    confirmationRegist: PropTypes.shape({
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
 
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.submit();
  }

  submit = () => {
    let values = {
      confirmation_token : this.props.match.params.confirmation_token
    }
    this.props.activeAccRequest(values, this.props.history)
  }

  backToLogin = () => {
    this.props.logout();
    this.props.history.push('/login');
  }

  render() {
    const {  
      handleSubmit, // remember, Redux Form injects this into our props
      confirmationRegist: {
        requesting,
        successful,
        messages,
        errors,
      },
    } = this.props
    
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6" xs="10">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <BlockUi tag="div" blocking={requesting}>
                    <h1>Active account</h1>
                    <Row>
                      <Col md="12">
                        {!requesting && !!errors.length && (
                          <Errors errors={errors} />
                        )}
                        {!requesting && !!messages.length && (
                          <Messages messages={messages} />
                        )}  
                        {!requesting && successful && (
                          <div>
                            <Button onClick={this.backToLogin} color="link" className="px-4" block>Click here to Login »</Button>
                          </div>
                        )}
                      </Col>
                    </Row>
                    </BlockUi>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

// Grab only the piece of state we need
const mapStateToProps = state => ({
  confirmationRegist: state.confirmationRegist,
})

const connected = connect(mapStateToProps, { activeAccRequest, logout })(ActiveAcc)

const formed = reduxForm({
  form: 'confirmationRegist',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Pages/ActiveAcc/ActiveAcc.js